import { isAdminRoute } from '@/constants/admin'

const HM_ID = (process.env.VUE_APP_BAIDU_HM_ID || '').trim()
let injected = false

function isOfficialTrackPath(path) {
  const p = String(path || '')
  if (!p) return false
  if (isAdminRoute(p)) return false
  if (p === '/login' || p === '/register') return false
  return true
}

/** 动态注入百度统计脚本（仅执行一次） */
export function ensureBaiduHm() {
  if (!HM_ID || injected || typeof document === 'undefined') return false
  if (document.querySelector(`script[data-baidu-hm="${HM_ID}"]`)) {
    injected = true
    return true
  }

  window._hmt = window._hmt || []
  // SPA：关闭自动 PV，改由路由手动上报，避免首次重复统计
  window._hmt.push(['_setAutoPageview', false])

  const hm = document.createElement('script')
  hm.src = `https://hm.baidu.com/hm.js?${HM_ID}`
  hm.async = true
  hm.setAttribute('data-baidu-hm', HM_ID)
  const s = document.getElementsByTagName('script')[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(hm, s)
  } else {
    document.head.appendChild(hm)
  }
  injected = true
  return true
}

/**
 * 官网前台 PV 上报；管理端 / 登录 / 注册不统计
 * @param {string} fullPath 路由 fullPath，如 /home、/news?id=1
 */
export function trackOfficialPageview(fullPath) {
  if (!HM_ID) return
  if (!isOfficialTrackPath(fullPath)) return
  if (!ensureBaiduHm()) return

  const path = fullPath.startsWith('/') ? fullPath : `/${fullPath}`
  window._hmt = window._hmt || []
  window._hmt.push(['_trackPageview', path])
}

/** 可选：自定义事件（按钮点击等） */
export function trackOfficialEvent(category, action, label, value) {
  if (!HM_ID) return
  if (typeof window === 'undefined') return
  // 仅在已处于官网统计上下文时上报；不主动给管理端注入脚本
  if (!injected && !document.querySelector(`script[data-baidu-hm="${HM_ID}"]`)) return
  window._hmt = window._hmt || []
  const args = ['_trackEvent', category, action]
  if (label != null) args.push(label)
  if (value != null) args.push(value)
  window._hmt.push(args)
}
